<template lang="html">
  <div>
    <van-swipe :autoplay="3000">
      <van-swipe-item>
          <img @click="toWorks" src="http://bbs.jmgo.com/static/image/banner_works.jpg" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img @click="toRecycle" src="http://bbs.jmgo.com/static/image/topic_may.jpg" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img src="http://bbs.jmgo.com/static/image/ad_bannerwx1.jpg" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img src="http://bbs.jmgo.com/static/image/ad_banner195.jpg" alt="">
        </van-swipe-item>
        <van-swipe-item>
          <img src="http://bbs.jmgo.com/static/image/ad_banner193.jpg" alt="">
        </van-swipe-item>
        
    </van-swipe>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Swipe,
  SwipeItem
} from 'vant'

Vue.use(Swipe).use(SwipeItem)

export default {
  methods: {
    toRecycle() {
      location.href = "https://www.jmgo.com/user.php?act=is_recycle_new&redirect=aihuishou&from=luntan"
    },
    toWorks() {
      location.href = "https://www.jmgo.com/activity/works"
    }
  },
}
</script>

<style lang="scss">
.van-swipe{
  height: 1.5rem;
  img{
    width: 100%;
    height: 100%;
  }
  .van-swipe__indicator--active{
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Swipe/Swipe.vue